(function () {
    //'use strict';
    app.controller('profileController', ['$filter', '$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', 'profileservice', '$route', 'LoginService', 'CommonService', 'UpgradeService', 'PaymentConfService', function ($filter, $scope, $location, $cookies, progressBarService, $rootScope, $timeout, profileservice, $route, loginService, commonService, upgradeService, paymentConfService) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
            $location.path('/login');
            return;
        }

        $scope.isAutorenewal = 1;

        if ($cookies.get('_trns') != undefined) {

            progressBarService.showProgressBar();

            var data = $cookies.get('_trns');
            $cookies.remove('_trns', { path: '/' });

            paymentConfService.confirmPayment($scope, data, "p");

        } else {
            $cookies.remove('_trns', { path: '/' });
        }

        $scope.isError = false;
        $scope.isSuccess = false;
        $scope.currentPage = 0;
        $scope.pageSize = 10;
        $scope.isValidZipCode = true;

        var hideMessage = function () {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = '';

            $scope.isModalError = false;
            $scope.isModalSuccess = false;
            $scope.modalMessage = '';
        }
        $scope.isEdited = false;
        $scope.disableProfile = function (flag) {
            $scope.disableFirstName = flag;
            $scope.disableLastName = flag;
            $scope.disableprofessionaltitle = flag;
            $scope.disableAreaOfInterest = flag;
            $scope.disablemobileNo = flag;
            $scope.disableWorkPhoneNum = flag;
            $scope.disableAffiliationName = flag;
            $scope.disableAdmin = flag;
            $scope.disableeSpectraEmail = flag;
            $scope.disabletermcodition = flag;
            $scope.disableInfoFlag = flag;
            $scope.disablePassword = flag;
            $scope.disableLatestProject = flag;
            $scope.disablePrimaryIndustry = flag;
            $scope.disableselectAffiliationName = flag;
            $scope.disableAddrs1 = flag;
            $scope.disableAddrs2 = flag;
            $scope.disableCity = flag;
            $scope.disableState = flag;
            $scope.disableCountry = flag;
            $scope.disableZipCode = flag;
            $scope.SSSPeerReviewerFlag = flag;
            //$scope.isprofileDisable = flag;
            $scope.btnUpdate = flag;
            $scope.btnCancel = flag;
            $scope.disableAutorenewal = flag;
            $scope.disableMktgOptInFlg = flag;
            flag ? $('.clearAffiliation').addClass('hide') : $('.clearAffiliation').removeClass('hide');

        }
        $scope.disableProfile(true);

        $scope.cancelProfile = function () {
            $location.path('profile');
            $route.reload();
        }

        $scope.viewProfile = "View Profile";

        $scope.editProfile = function () {
            $('.selected-flag ').removeClass('disable');
            //$scope.isprofileDisable = false;

            $scope.btnUpdate = false;
            $scope.btnCancel = false;

            $('.clearAffiliation').addClass('hide');

            if ($scope.profileData.eSpectraPrimaryAffiliationName.length > 0) {
                $scope.disableselectAffiliationName = true;
                $('.clearAffiliation').removeClass('hide');
            }
            $('.administrator').hide();
            $('.administrator1').show();
            $scope.disableProfile(false);

            $scope.disableeSpectraEmail = true;
            $scope.disablePurchaseBtn = true;
            $scope.disableAffiliationName = $scope.profileData.isTeamMember == 1 ? true : false;
            $scope.disableselectAffiliationName = $scope.profileData.isTeamMember == 1 ? true : false;
            $scope.viewProfile = "Edit Profile";
            $scope.btnEdit = true;

            var UserRoleStatus = getLocalValue("userRoleStatus");
            if (UserRoleStatus != 'active' && UserRoleStatus != "") {
                $scope.pending = "(Pending Approval)";
                $('.administrator').show();
                $('.administrator1').hide()
            }
            if (UserRoleStatus.toLowerCase() == 'active') {
                $('.administrator').show();
                $('.administrator1').hide()

            }

        }

        $scope.selectAffiliation = function () {
            $scope.selectedInstitute.userDefinedAffiliation = "";
            $scope.selectedInstitute.InstitutionId = $scope.profileData.InstitutionId;
            if (!$scope.selectedInstitute.isAffiliationExists) {
                $scope.selectedInstitute.InstitutionName = $scope.profileData.eSpectraPrimaryAffiliationName;
                $scope.selectedInstitute.InstitutionName = $scope.profileData.eSpectraPrimaryAffiliationName;
            } else {
                if ($scope.profileData.eSpectraPrimaryAffiliationName.length == 0) {
                    $scope.selectedInstitute.isAffiliationExists = false
                    //$('#affiliationName').removeAttr('disabled');
                }
                //$scope.selectedInstitute.userDefinedAffiliation = $scope.profileData.eSpectraPrimaryAffiliationName;
            }

            $('#affiliation').modal('show');
        }

        $scope.validatePassword = function (event) {
            commonService.validatePassword($scope, event);
        }

        $scope.profileDataModel = function () {
            $scope.profileData = {
                eSpectraLastUpdateUserID: "",
                eSpectraFirstName: "",
                eSpectraLastName: "",
                eSpectraMobilePhoneNum: "",
                eSpectraStreetAddrs1: "",
                eSpectraStreetAddrs2: "",
                eSpectraCity: "",
                eSpectraCountryID: "",
                eSpectraPrimaryIndustry: "",
                eSpectraLatestProject: "",
                eSpectraSSSPeerReviewerFlag: "",
                eSpectraStateCode: "",
                eSpectraOtherState: "",
                eSpectraZipPostalCode: "",
                eSpectraWorkPhoneNum: "",
                eSpectraEmail: "",
                registeredPassword: "",
                retypePassword: "",
                eSpectraPrimaryAreaOfInterest: "",
                eSpectraProfessionalTitle: "",
                eSpectraTermConditionAgreeTS: false,
                InstitutionId: "",
                eSpectraPrimaryAffiliationName: "",
                eSpectraIsAdmin: false,
                eSpectraReceiveInfoFlag: false,
                eSpectraMktgOptInFlg: true
            }
        }

        $scope.selectedInstitute = {
            InstitutionId: 0,
            InstitutionName: '',
            isAffiliationExists: false,
            userDefinedAffiliation: ''
        };

        $scope.profileDataModel();

        $("#instituteName").on('focusout', function () {
            $('#instituteName').typeahead('close');

            $scope.profileData.eSpectraPrimaryAffiliationName = $('#instituteName').val();

            $scope.$apply();
            return false;
        });

        $scope.getprofileData = function () {
            var emailId, UserRole, UserRoleStatus;
            emailId = getLocalValue('emailId');
            UserRole = getLocalValue("userRole");
            UserRoleStatus = getLocalValue("userRoleStatus");
            progressBarService.showProgressBar();

            profileservice.getprofileData(emailId).then(function (response) {

                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    $scope.profileData = response.data;
                    $scope.profileData.eSpectraCountryID = response.data.eSpectraCountryID.toString() == "1" ? "" : response.data.eSpectraCountryID.toString();
                    $scope.profileData.InstitutionId = response.data.eSpectraPrimaryAffiliationID;
                    $scope.profileData.InstitutionName = response.data.eSpectraPrimaryAffiliationName;
                    $scope.profileData.eSpectraOtherState = response.data.eSpectraStateCode;
                    $scope.profileData.eSpectraMktgOptInFlg = $scope.profileData.eSpectraMktgOptInFlg == 1 ? true : false;

                    setLocalValue("userRoleStatus", response.data.eSpectraUserRoleStatus);

                    if (response.data.eSpectraSSSPeerReviewerFlag == 1) {
                        $scope.profileForm.eSpectraSSSPeerReviewerFlag = true;
                    } else {
                        $scope.profileForm.eSpectraSSSPeerReviewerFlag = false;

                    }

                    var MobilePhoneNum = $scope.profileData.eSpectraMobilePhoneNum;
                    var mobilenumber = MobilePhoneNum.split('-');
                    var WorkPhoneNum = $scope.profileData.eSpectraWorkPhoneNum;
                    var worknumber = WorkPhoneNum.split('-');

                    if ($scope.profileData.eSpectraMobilePhoneNum.length > 0) {
                        $("#mobileNo").intlTelInput("setNumber", mobilenumber[0]);
                        $scope.profileData.eSpectraMobilePhoneNum = mobilenumber[1] == undefined ? "" : mobilenumber[1];

                    }
                    if ($scope.profileData.eSpectraWorkPhoneNum.length > 0) {
                        $("#workNo").intlTelInput("setNumber", worknumber[0]);
                        $scope.profileData.eSpectraWorkPhoneNum = worknumber[1] == undefined ? "" : worknumber[1];
                    }

                    if (UserRoleStatus.toLowerCase() == 'active') {
                        $('.administrator').show();
                        $('.administrator1').hide()

                    } else {
                        if (UserRole != " " && UserRoleStatus != 'pending' && UserRoleStatus != 'rejected' && UserRoleStatus != "") {

                            $('.administrator').hide();
                            $('.administrator1').show();

                            $scope.profileData.eSpectraIsAdmin = true;
                        }
                        else if (UserRoleStatus != 'active' && UserRoleStatus != '') {
                            $scope.pending = "(Pending Approval)";
                            $('.administrator').show();
                            $('.administrator1').hide()
                        }
                        else if (UserRoleStatus == "") {
                            $('.administrator').hide();
                        }
                    }
                    if (response.data.eSpectraReceiveInfoFlag == 1) {
                        response.data.eSpectraReceiveInfoFlag = true;
                    }
                    $scope.getUserSubPackPurchaseDetails();
                }

            });
        }

        $scope.getprofileData();

        $scope.getUserSubPackPurchaseDetails = function () {
            progressBarService.showProgressBar();

            profileservice.getUserSubPackPurchaseDetails().then(function (response) {

                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    progressBarService.hideProgressBar();
                    //$timeout(hideMessage, 10000);
                } else {
                    $scope.hasPremiumSubscription = localStorage.pre;
                    $scope.userSubpackPurchaseDetails = response.data.userSubPackDetails;
                    angular.forEach($scope.userSubpackPurchaseDetails, function (value, key) {
                        if (value.premiumType.toLowerCase() == 'premium') {
                            $scope.hasPremiumSubscription = true;
                        }
                    });
                    $scope.userCurrentSubscription = response.data.activeSubpack;
                    $scope.userCurrentSubscription.startEndDate = $filter('date')($scope.userCurrentSubscription.eSpectraOrderStartDate, 'longDate') + " - " + $filter('date')($scope.userCurrentSubscription.eSpectraOrderEndDate, 'longDate');
                    $scope.userCurrentSubscription.eSpectraCCLast4Num = '...' + $scope.userCurrentSubscription.eSpectraCCLast4Num;
                    $scope.isAutorenewal = $scope.userCurrentSubscription.eSpectraRecurringBillFlag;
                    $scope.disablePurchaseBtn = $scope.userCurrentSubscription.eSpectraRecurringBillFlag == 1 ? true : false;
                    $('#on').attr('recurring', $scope.isAutorenewal);
                    $scope.getcountryData();
                    progressBarService.hideProgressBar();
                }
            });
        };

        $scope.getcountryData = function () {
            profileservice.getcountryData().then(function (response) {
                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.countries = response.data;
                    $scope.getStateByCountryID();
                }
            });

        }

        $scope.getStateByCountryID = function () {
            var AipCountryCode = "";
            var AipCountryID = $scope.profileData.eSpectraCountryID == "" ? "1" : $scope.profileData.eSpectraCountryID;
            var AipCountryCode = "";
            if (AipCountryID) {
                $scope.getstateData(AipCountryID, AipCountryCode);
            }
            if ($scope.profileData.eSpectraZipPostalCode != '') {
                this.profileData.$dirty = true;
                this.profileData.eSpectraZipPostalCode.$dirty = true;
            }
        }

        //to test zip code valid or not at the time of page load
        $scope.$on('$viewContentLoaded', function () {
            $timeout(function () {
                $scope.selectedCountryZipCodeRegEx = $('option:selected', $('#country')).attr('validateRegex');
                if ($scope.profileData.eSpectraZipPostalCode != '') {
                    var emailregx = new RegExp($scope.selectedCountryZipCodeRegEx);
                    if (!emailregx.test($scope.profileData.eSpectraZipPostalCode)) {
                        $scope.profileForm.eSpectraZipPostalCode.$dirty = true;
                        $scope.profileForm.eSpectraZipPostalCode.$invalid = true;
                    }
                }
            }, 2000);
        });

        $scope.getstateData = function (AipCountryID, AipCountryCode) {

            $scope.selectedCountryZipCodeRegEx = $('option:selected', $('#country')).attr('validateRegex');

            profileservice.getstateData(AipCountryID, AipCountryCode).then(function (response) {

                if (response != null && response.data.message != undefined) {

                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {

                    progressBarService.hideProgressBar();
                    $scope.states = response.data;
                    if (response.data.length > 0) {
                        $scope.profileData.eSpectraOtherState = "";
                    } else {
                        $scope.profileData.eSpectraStateCode = "";
                    }

                }
                progressBarService.hideProgressBar();
            });
        }

        $scope.ShowAutorenewalPopup = function () {
            if ($scope.profileForm.$valid) {
                var isAutorenewal = $('#on')[0].checked ? 1 : 0;
                var eSpectraCancelRecurring = $('#on').attr('recurring');
                $scope.eSpectraOrderIsMonthly = true;
                if (eSpectraCancelRecurring == 0 && isAutorenewal == 1) {
                    $scope.getProducts();
                } else {
                    $scope.updateProfile();
                }
            }
        }

        $scope.ValidateUserDetails = function () {
            var returnVal = true;
            if (angular.element("#lastName").val() != '') {
                $("#lastName").removeClass("border-red");
                $("#lastName").siblings('span').find("span.error-msg").addClass('display-none')
                var regExp = /^[a-zA-Z](?!.*-.*-.*)(?!.*\s.*\s.*)[a-zA-Z- ]+$/;
                var isValid = regExp.test(angular.element("#lastName").val());
                if (isValid) {
                    $("#lastName").removeClass("border-red");
                    $("#lastName").siblings('span').find("span.error-msg").addClass('display-none')
                }
                else {
                    if (returnVal) {
                        $("#lastName").focus();
                    }
                    $("#lastName").siblings('span').find("span.error-msg").removeClass('display-none')
                    returnVal = false;
                }
            }
            else {
                //$("#lastName").addClass("border-red");
                if (returnVal) {
                    $("#lastName").focus();
                }
                $("#lastName").siblings('span').find("span.error-msg").removeClass('display-none')
                returnVal = false;
            }

            if (!returnVal) {
                this.profileForm.eSpectraLastName.$dirty = true;
            }

            return returnVal;
        }

        $scope.CancelAutorenewalPopup = function () {
            $scope.isAutorenewal = 0;
            $('#on')[0].checked = false;
            angular.element(document.querySelector('#offLbl')).addClass('active');
            angular.element(document.querySelector('#onLbl')).removeClass('active');
            $scope.updateProfile();
            $('#showAutorenewalDialog').modal('hide');
        }

        $scope.updateProfile = function () {
            if ($scope.checkZipCode()) {
                $('#showAutorenewalDialog').modal('hide');

                progressBarService.showProgressBar();

                //var eSpectraLastUpdateUserID = $cookies.get('UserId');
                var countryCode, countryCode1, eSpectraReceiveInfoFlag, eSpectraIsAdmin, userInfo, eSpectraSSSPeerReviewerFlag;
                countryCode = $('#mobileNo').parent().find('.selected-dial-code').text() + "-";
                countryCode1 = $('#workNo').parent().find('.selected-dial-code').text() + "-";
                eSpectraReceiveInfoFlag = $('#eSpectraReceiveInfoFlag').is(":checked");
                eSpectraIsAdmin = $('#eSpectraIsAdmin').is(":checked") && getLocalValue("userRoleStatus") == '' ? true : false;
                eSpectraSSSPeerReviewerFlag = 0;//$('#yes')[0].checked ? 1 : 0;
                $scope.isAutorenewal = $('#on')[0].checked ? 1 : 0;
                $scope.eSpectraCancelRecurring = $('#on').attr('recurring');

                userInfo = {
                    //eSpectraLastUpdateUserID: eSpectraLastUpdateUserID,
                    eSpectraFirstName: $scope.profileData.eSpectraFirstName,
                    eSpectraLastName: $scope.profileData.eSpectraLastName,
                    eSpectraEmail: $scope.profileData.eSpectraEmail,
                    eSpectraProfessionalTitle: $scope.profileData.eSpectraProfessionalTitle,
                    eSpectraPrimaryAreaOfInterest: $scope.profileData.eSpectraPrimaryAreaOfInterest,
                    eSpectraMobilePhoneNum: countryCode + $scope.profileData.eSpectraMobilePhoneNum,
                    eSpectraWorkPhoneNum: countryCode1 + $scope.profileData.eSpectraWorkPhoneNum,
                    eSpectraStreetAddrs1: $scope.profileData.eSpectraStreetAddrs1,
                    eSpectraStreetAddrs2: $scope.profileData.eSpectraStreetAddrs2,
                    eSpectraCity: $scope.profileData.eSpectraCity,
                    eSpectraZipPostalCode: $scope.profileData.eSpectraZipPostalCode,
                    eSpectraCountryID: $scope.profileData.eSpectraCountryID == "" ? "1" : $scope.profileData.eSpectraCountryID,
                    eSpectraPrimaryIndustry: $scope.profileData.eSpectraPrimaryIndustry,
                    eSpectraLatestProject: $scope.profileData.eSpectraLatestProject,
                    eSpectraSSSPeerReviewerFlag: eSpectraSSSPeerReviewerFlag,

                    eSpectraStateCode: $scope.profileData.eSpectraStateCode == "" ? $scope.profileData.eSpectraOtherState : $scope.profileData.eSpectraStateCode,

                    eSpectraReceiveInfoFlag: eSpectraReceiveInfoFlag == true ? 1 : 0,
                    eSpectraPrimaryAffiliationID: parseInt($scope.profileData.InstitutionId) > 0 ? $scope.profileData.InstitutionId : 1,
                    eSpectraPrimaryAffiliationName: $scope.profileData.InstitutionName,
                    eSpectraIsAdmin: eSpectraIsAdmin == true ? 1 : 0,
                    eSpectraRecurringBillFlag: $scope.isAutorenewal,
                    eSpectraCancelRecurring: $scope.eSpectraCancelRecurring,
                    eSpectraOrderID: $scope.userCurrentSubscription.eSpectraOrderID,
                    eSpectraOrderIsMonthly: $scope.eSpectraOrderIsMonthly == true ? 1 : 0,
                    eSpectraMktgOptInFlg: $scope.profileData.eSpectraMktgOptInFlg == true ? 1 : 0
                };

                profileservice.saveProfileData(userInfo).then(function (response) {

                    if (response != null && response.data.message != undefined) {
                        $scope.message = response.data.message;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                        //$timeout(hideMessage, 10000);
                        progressBarService.hideProgressBar();
                    }
                    else {
                        if (response.data == false) {
                            $scope.message = "Profile updation fail.";
                            $scope.isError = true;
                            $scope.isSuccess = false;
                            //$timeout(hideMessage, 10000);
                            progressBarService.hideProgressBar();
                        }
                        else {
                            $('.login-fullName').text(userInfo.eSpectraFirstName + " " + userInfo.eSpectraLastName);
                            setLocalValue("fullName", userInfo.eSpectraFirstName + " " + userInfo.eSpectraLastName);

                            if (response.data.cyberSourceStatus == true) {
                                $scope.message = "Your profile has been updated successfully.";
                                $scope.isError = false;
                                $scope.isSuccess = true;
                                if (userInfo.eSpectraCancelRecurring == 1 && userInfo.eSpectraRecurringBillFlag == 0) {
                                    $scope.isAutorenewal = 0;
                                    $scope.userCurrentSubscription.eSpectraRecurringBillFlag = 0;
                                    $('#on')[0].checked = false;
                                    angular.element(document.querySelector('#offLbl')).addClass('active');
                                    angular.element(document.querySelector('#onLbl')).removeClass('active');

                                    $scope.getprofileData();
                                }
                            } else if (userInfo.eSpectraCancelRecurring == 1 && userInfo.eSpectraRecurringBillFlag == 0 && response.data.cyberSourceStatus == false) {
                                $scope.message = 'Your cancellation of Auto-renewal has failed. Please contact Customer Service.';
                                $scope.isError = true;
                                $scope.isSuccess = false;
                                $scope.isAutorenewal = 1;
                                $('#on')[0].checked = true;
                                angular.element(document.querySelector('#offLbl')).removeClass('active');
                                angular.element(document.querySelector('#onLbl')).addClass('active');
                                progressBarService.hideProgressBar();
                            }
                            if (userInfo.eSpectraCancelRecurring == 0 && userInfo.eSpectraRecurringBillFlag == 1) {
                                $scope.getAutoRenewalSignature(userInfo);
                            }

                            //$timeout(hideMessage, 10000);
                        }
                    }
                    progressBarService.hideProgressBar();
                    $scope.disableProfile(true);
                    $scope.disablePurchaseBtn = $scope.userCurrentSubscription.eSpectraRecurringBillFlag == 1 ? true : false;
                    $scope.btnEdit = false;
                });
            }
        };

        $scope.getAutoRenewalSignature = function (upgradeData) {
            progressBarService.showProgressBar();
            profileservice.turnOnRecurringSubscription(upgradeData).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {

                    var data = response.data.signature;

                    $scope.cybersourceAPI = response.data.signature.CyberSourceTokenAPI;
                    document.autorenewal_payment_confirmation.action = $scope.cybersourceAPI;

                    var payData = {
                        access_key: data.access_key,
                        profile_id: data.profile_id,
                        transaction_uuid: data.transaction_uuid,
                        signed_field_names: data.signed_field_names,
                        unsigned_field_names: data.unsigned_field_names,
                        signed_date_time: data.signed_date_time,
                        locale: data.locale,
                        transaction_type: data.transaction_type,
                        reference_number: data.reference_number,
                        amount: data.amount,
                        currency: data.currency,
                        signature: data.signature,
                        bill_to_forename: data.bill_to_forename,
                        bill_to_surname: data.bill_to_surname,
                        bill_to_email: data.bill_to_email,
                        bill_to_address_line1: data.bill_to_address_line1,
                        bill_to_address_line2: data.bill_to_address_line2,
                        bill_to_address_city: data.bill_to_address_city,
                        bill_to_address_postal_code: data.bill_to_address_postal_code,
                        bill_to_address_state: data.bill_to_address_state,
                        bill_to_address_country: data.bill_to_address_country,
                        recurring_frequency: data.recurring_frequency,
                        recurring_amount: data.recurring_amount,
                        recurring_start_date: data.recurring_start_date,
                        override_custom_cancel_page: data.override_custom_cancel_page,
                        override_custom_receipt_page: data.override_custom_receipt_page,
                        override_backoffice_post_url: data.override_backoffice_post_url
                    }

                    $scope.GetSignature = payData;

                    window.setTimeout(function () {
                        $('#autorenewalsubmit').click();
                    }, 100)
                }
                progressBarService.hideProgressBar();
            });
        }

        $scope.registrationData = {
            currentPassword: '',
            registeredPassword: '',
            confirmPassword: ''
        }

        var clearChangePasswordDialog = function () {

            $scope.registrationData.currentPassword = '';
            $scope.registrationData.registeredPassword = '';
            $scope.registrationData.confirmPassword = '';
            $scope.PasswordLength = false;
            $scope.UpperCase = false;
            $scope.Numbers = false;
            $scope.SpecialCharacters = false;

            //$('#currentPassword').val('');
            //$('#newPassword').val('');
            //$('#confirmPassword').val('');
            $rootScope.$broadcast('reloadCaptcha', {});
            $("form[name=frmChangepwd]").trigger('reset');
            $('.border-red').removeClass('border-red');
            $scope.frmChangepwd.$setPristine();
            $scope.frmChangepwd.$setUntouched();
            hideMessage();
        }

        $scope.closechangePasswordDialog = function () {
            clearChangePasswordDialog();
        }

        $scope.changePasswordDialog = function () {
            clearChangePasswordDialog();
            $('#changePasswordDialog').modal({ backdrop: 'static', keyboard: false });
        }

        $scope.changePassword = function () {
            var data = {
                eSpectraEmail: getLocalValue('emailId'),
                eSpectraPassword: $scope.registrationData.registeredPassword,
                eSpectraCurrentPassword: $scope.registrationData.currentPassword
            }

            progressBarService.showProgressBar();
            profileservice.resetPassword(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.modalMessage = response.data.message;
                    $scope.isModalError = true;
                    $scope.isModalSuccess = false;
                    $('#currentPassword').addClass('border-red');
                    //$timeout(hideMessage, 10000);
                }
                else {
                    //loginService.logOut();
                    progressBarService.hideProgressBar();
                    $('#changePasswordDialog').modal('hide');
                    //$location.path('/passwordResetConfirmation');
                }
                progressBarService.hideProgressBar();
            });
        }

        $scope.Alertdelete = function () {
            $scope.alerts = {
                alerHeaderMessage: '',
                alertBodyMessage: ''
            }
            $scope.alerts.alerHeaderMessage = GetMessage.recordsDeleteHeader;
            $scope.alerts.alertBodyMessage = GetMessage.recordsDeleteBody;

            $('#confirmDelete').modal({ backdrop: 'static', keyboard: false });
        }

        $scope.delete = function () {
            $('#confirmDelete').modal('hide');
            progressBarService.showProgressBar();
            //var eSpectraLastUpdateUserID = $cookies.get('UserId');
            var eSpectraEmail = getLocalValue('emailId');
            var userInfo = {
                //eSpectraPersonID: eSpectraLastUpdateUserID,
                //eSpectraLastUpdateUserID: eSpectraLastUpdateUserID,
                eSpectraFirstName: $scope.profileData.eSpectraFirstName
            }

            profileservice.deleteRecords(userInfo).then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    progressBarService.hideProgressBar();
                } else {
                    $scope.message = "Account Deleted Successfully.";
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    sendConfirmationToUserDelete(eSpectraEmail, userInfo.eSpectraFirstName);
                    $timeout(function () {
                        progressBarService.hideProgressBar();
                        loginService.logOut();
                        $location.path('/home');
                    }, 1000);
                }
            });
        }

        var sendConfirmationToUserDelete = function (userId, eSpectraFirstName) {
            loginService.sendConfirmationToUserDelete(userId, eSpectraFirstName);
        };

        var deactivateAccount = function () {
            progressBarService.showProgressBar();
            //var eSpectraLastUpdateUserID = $cookies.get('UserId');
            //var userInfo = {
            //    eSpectraLastUpdateUserID: eSpectraLastUpdateUserID,
            //    eSpectraPersonID: eSpectraLastUpdateUserID
            //}

            profileservice.deactivateAccount().then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                } else {
                    $scope.message = "Account Deactivated Successfully.";
                    loginService.logOut();
                    progressBarService.hideProgressBar();
                    $timeout($location.path('/login'), 10000);
                    return false;
                }
                progressBarService.hideProgressBar();
            });
        };

        var deleteRecords = function () {
            progressBarService.showProgressBar();
            //var eSpectraLastUpdateUserID = $cookies.get('UserId');
            //var userInfo = {
            //    eSpectraLastUpdateUserID: eSpectraLastUpdateUserID
            //}

            profileservice.deleteRecords().then(function (response) {

                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                } else {
                    $scope.message = "Records Deleted Successfully.";
                    $scope.isError = false;
                    $scope.isSuccess = true;
                }
                //$timeout(hideMessage, 10000);
                progressBarService.hideProgressBar();
            });
        };

        $scope.getSignature = function () {

            profileservice.getUpdateCCSignature().then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    $scope.isAutorenewal = 0;
                    $('#on')[0].checked = false;
                    angular.element(document.querySelector('#offLbl')).addClass('active');
                    angular.element(document.querySelector('#onLbl')).removeClass('active');
                }
                else {

                    var data = response.data.signature;
                    $scope.cybersourceUpdateAPI = response.data.signature.CyberSourceTokenAPI;
                    document.update_payment.action = $scope.cybersourceUpdateAPI;

                    var payData = {
                        access_key: data.access_key,
                        profile_id: data.profile_id,
                        transaction_uuid: data.transaction_uuid,
                        signed_field_names: data.signed_field_names,
                        unsigned_field_names: data.unsigned_field_names,
                        signed_date_time: data.signed_date_time,
                        locale: data.locale,
                        transaction_type: data.transaction_type,
                        reference_number: data.reference_number,
                        signature: data.signature,
                        payment_token: data.subscription_id,
                        allow_payment_token_update: data.allow_payment_token_update,
                        override_custom_cancel_page: data.override_custom_cancel_page,
                        override_custom_receipt_page: data.override_custom_receipt_page,
                        override_backoffice_post_url: data.override_backoffice_post_url
                    }

                    $scope.GetSignature = payData;

                    window.setTimeout(function () {
                        $('#update_payment #submit').click();
                    }, 100)

                    progressBarService.hideProgressBar();
                }
            });
        }

        $scope.getProducts = function () {
            upgradeService.getSubscriptionProducts().then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.subPackMessage = response.data.message;
                    $scope.subPackIsError = true;
                    $scope.subPackIsSuccess = false;
                }
                else {
                    $scope.monthlySubscriptions = response.data.monthlySusription;
                    $scope.annualSubscriptions = response.data.yearlySuscription;
                    $('#showAutorenewalDialog').modal('show');
                }
            });
        }

        $scope.checkZipCode = function () {
            var codeRegEx = $("#country_" + $scope.profileData.eSpectraCountryID).attr('validateRegex');
            var emailregx = new RegExp(codeRegEx);
            if ($scope.profileData.eSpectraZipPostalCode != "" && !emailregx.test($scope.profileData.eSpectraZipPostalCode)) {
                $scope.profileForm.eSpectraZipPostalCode.$dirty = true;
                $scope.profileForm.eSpectraZipPostalCode.$invalid = true;
                $scope.isValidZipCode = false;
                return false;
            } else {
                $scope.profileForm.eSpectraZipPostalCode.$dirty = false;
                $scope.profileForm.eSpectraZipPostalCode.$invalid = false;
                $scope.isValidZipCode = true;
                return true;
            }
        }
    }]);

    app.filter('startFrom', function () {
        return function (input, start) {
            start = +start;
            return input.slice(start);
        }
    });

})();